// MonsterPage

import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { fetchCard } from '../common/common';
import { CardInfo} from '../common/cardinfo';
import monster from './monsters.json';
import { GiSeaCreature } from "react-icons/gi";
import { MdLandscape } from "react-icons/md";
import { ImgInventoryRow } from '../carddeck/thumb';

function Iframe(props) {
  return (<div dangerouslySetInnerHTML={ {__html:  props.iframe?props.iframe:""}} />);
}

export function MonsterInfo(props) {
    const monster = props.monster;
    const imgMapURL = "https://media.mythicalbeings.io/maps/Map_"+monster.name+".jpg"

    return(
      <div style={{textAlign:"center", maxWidth:"600px", width:"90%", display:"inline-block",   justifyContent:'center', alignItems:'center',}} >

          <Grid container
            justify="space-evenly"
            direction="column"
            alignItems="stretch"
            spacing={24}
          >
           

            <Grid item  style={{textAlign:"left"}}>
            <Grid container spacing={24}
                    justify="center"
                    alignItems="center"
                    direction="column"
                >
            <img src={"https://media.mythicalbeings.io/creatures/"+monster.picture} alt=""  style={{marginTop: 18, borderRadius: 5, boxShadow: "5px 5px 8px rgba(3, 3, 3, 0.32)", alignItems:"center", justifyContent:"center", maxWidth:"600px",width:'90%'}}/>

              <Typography>&nbsp;</Typography>
              <Typography variant="body1">{monster.continent} / {monster.country} / {monster.name}</Typography>
              <Typography variant="display1" style={{textAlign:"left"}}>Creature <GiSeaCreature/></Typography>
              {
                monster.creature.map((c,index)=>(<Typography key={index} variant="body1" style={{textAlign:"justify",maxWidth:"600px",width:"90%", display:"inline-block",   justifyContent:'center', alignItems:'center'}}>{c}</Typography>))
              }
              
              <Typography>&nbsp;</Typography>
     
           
              <img src={"https://media.mythicalbeings.io/landscapes/"+monster.landscape} alt=""  style={{borderRadius: 5, boxShadow: "5px 5px 8px rgba(3, 3, 3, 0.32)", alignItems:"center", justifyContent:"center", maxWidth:"600px",width:'90%'}}/>
   
              <Typography>&nbsp;</Typography>
              <Typography variant="display1" style={{textAlign:"left"}}>Culture <MdLandscape /></Typography>
              
              {
                monster.culture.map((c,index)=>(<Typography key={index} variant="body1" style={{textAlign:"justify",maxWidth:"600px",width:"90%", display:"inline-block",   justifyContent:'center', alignItems:'center'}}>{c}</Typography>))
              }
               <Typography>&nbsp;</Typography>
               
                <img src={imgMapURL === 'https://media.mythicalbeings.io/maps/Map_/Kaggen.jpg' ? 'https://media.mythicalbeings.io/maps/Map_Mantis.jpg' : imgMapURL } alt=""  style={{borderRadius: 5, boxShadow: "5px 5px 8px rgba(3, 3, 3, 0.32)", alignItems:"center", justifyContent:"center", maxWidth:"600px",width:'90%'}}/>
                
                       <Typography>&nbsp;</Typography>
               <Iframe iframe={monster.maplink}  />
               <Typography>&nbsp;</Typography>
            </Grid>   
            </Grid>  
          </Grid>
        </div>
    )
}

export class MonsterPage extends Component {
  constructor(props){
    super(props);
    this.state={
        card:{}
    }
    this.refresh = this.refresh.bind(this);
    //console.log(monster);
}

refresh(){
    var self = this;
    //console.log(this.props);
    fetchCard(this.props.nodeurl,this.props.user.accountRs,this.props.match.params.asset)
    .then((response)=>{
      //console.log(response);
      let card = response;
      card.more =  monster.find((m)=>m.assetname === response.assetname); 
      //console.log(card.more);
      self.setState({card:card});
    })
    .catch((err)=>{console.log(err)});
}


componentDidMount(){
    this.refresh();
    this.timer = setInterval(this.refresh,9000);
  }

componentWillUnmount(){
    clearInterval(this.timer);
}


  render() {
    const m = this.state.card.more === undefined ? {continent:"",country:"",culture:[],creature:[],maplink:""} : this.state.card.more;
    return (
      <div style={{textAlign:"center", width:"90%", display:"inline-block",   justifyContent:'center', alignItems:'center',  backgroundColor: '#1D1D1D', marginTop: 5,marginBottom: 5}} >

        <Grid container spacing={8}
            className="boxed"
            justify="center"
            alignItems="flex-start"
            direction="row"
            style={{ marginTop: 5, border:'1px solid', borderColor:'#ffffff10',boxShadow: "5px 5px 8px rgba(5, 5, 5, 0.32)"}}>
            <Grid item>

              <Grid container spacing={12}
                    justify="center"
                    alignItems="center"
                    direction="column"
                >
                  <Grid item>
                    <ImgInventoryRow card={this.state.card}></ImgInventoryRow>
                    <CardInfo card={this.state.card}/> 
                    <Typography>&nbsp;</Typography>
                  </Grid> 
                  {/* <Grid item>
                                <Link style={{textDecoration: 'none'}} to={"/game/place/bid/"+this.state.card.asset}>
                                    <Button fullWidth variant="outlined" disabled={!posess}>Place a Buy Order (Bid)</Button>
                                </Link>        
                            </Grid>
                            <Grid item>
                                <Link style={{textDecoration: 'none'}} to={"/game/place/ask/"+this.state.card.asset}>
                                    <Button fullWidth variant="outlined" disabled={!posess}>Offer this Card (Ask)</Button>
                                </Link>        
                            </Grid>
                            <Grid item>
                                <Link style={{textDecoration: 'none'}} to={"/game/send/"+this.state.card.asset}>
                                    <Button fullWidth variant="outlined" disabled={!posess}> Send</Button>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link style={{textDecoration: 'none'}} to={"/game/learnmore/"+this.state.card.asset}>
                                    <Button fullWidth variant="outlined" disabled={!posess}> Learn More</Button>
                                </Link>
                            </Grid> */}
      

              </Grid>
            </Grid>
            <Grid item style={{maxWidth:"600px"}}>
              <MonsterInfo monster={m}/>
            </Grid>

        </Grid>
      </div>
    )
  }
}